import React from 'react';
import { Page, Text, View, Image } from '@react-pdf/renderer';
import dateFormat from 'dateformat';

import hgsdLogo from '../../black-textHGSDlogo400px.png';
import ftBendLogo from '../../fbsd_logo_clr_rgb.png';

export default function AppendixE({ styles, data, year, month, footer }) {
  return (
    <Page size='A4'>
      <View style={styles.pageTitle}>
        <Text style={styles.pageTitle}></Text>
      </View>
      <View style={styles.document}>
        <View style={[styles.row, styles.borderBottom]}>
          <Image
            src={window.config.client === 'FT-BEND' ? ftBendLogo : hgsdLogo}
            style={styles.logo}
          />
          <Text style={styles.logoLabel}>Appendix E</Text>
        </View>
        <View style={[styles.row, styles.borderBottom]}>
          <Text style={styles.logo} />
          <Text style={styles.logoLabel}>Administrative Modifications</Text>
        </View>
        <View style={styles.section}>
          <Text>Modification to Board Action</Text>
        </View>
        <View style={styles.section}>
          {data.length === 0 ? (
            <View style={styles.column}>
              <Text>NONE</Text>
            </View>
          ) : null}
          {data.map((permit, i) => (
            <View style={styles.section} key={i}>
              <View>
                <Text style={styles.headerLabel}>PERMITTEE:</Text>
                <Text>{permit.PERMITTEE}</Text>
              </View>
              <View>
                <Text style={styles.headerLabel}>WELL NOS.:</Text>
                <Text>{permit.WELL_NOS}</Text>
              </View>
              <View>
                <Text style={styles.headerLabel}>BOARD ACTION:</Text>
                <Text>{` ${dateFormat(
                  permit.TARGET_END_DATE,
                  'mmmm d, yyyy',
                  true
                )}`}</Text>
              </View>
              <View>
                <Text style={styles.headerLabel}>MODIFICATION:</Text>
                <Text>{permit.MODIFICATIONS}</Text>
              </View>
              <View>
                <Text style={styles.headerLabel}>RECOMMENDATIONS:</Text>
                <Text>{permit.RECOMMENDATIONS}</Text>
              </View>
              <View>
                <Text style={styles.headerLabel}>TESTIMONY AND FINDINGS:</Text>
                <Text>{permit.FINDINGS}</Text>
              </View>
            </View>
          ))}
        </View>
      </View>
      <View fixed style={styles.footer}>
        {/* <Text style={styles.data}>{footer}</Text> */}
        <Text
          style={styles.data}
          render={({ pageNumber, totalPages }) =>
            `${footer} (${pageNumber}/${totalPages})`
          }
        />
      </View>
    </Page>
  );
}
